import { useQuery, UseQueryResult } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';
import { CommonKey, Client } from '../../types/api';
import { useRightsholderAttribution } from './useRightsholderAttribution';

type ClientRsp = {
    rightsholder: { id: number; name: string };
    sponsor: { id: number; name: string };
    placement: any;
};

const fetchClientRsps = async (
    clientId: number,
    useRightsholderAttribution: boolean,
): Promise<ClientRsp[]> => {
    const response = await sportsApi
        .url(
            `/clients/${clientId}/rsps${
                useRightsholderAttribution
                    ? '?useRightsholderAttribution=true'
                    : ''
            }`,
        )
        .get()
        .json<ClientRsp[]>();
    return response;
};

const useClientRsps = (
    clientId: number,
    client?: Client | null,
): UseQueryResult<ClientRsp[]> => {
    const { rightsholderAttribution } = useRightsholderAttribution({ client });

    return useQuery<ClientRsp[]>({
        queryKey: [CommonKey.ClientRsps, clientId, rightsholderAttribution],
        queryFn: () =>
            fetchClientRsps(clientId, rightsholderAttribution === 'league'),
        enabled: !!clientId,
    });
};

export default useClientRsps;
